import {
  DevNotice,
  useThemeProps,
  ensureArray,
  handleComponentsProp,
  upperCamelCase,
} from "../../wsui/base";

import DefaultHit from "./DefaultHit.jsx";

// eslint-disable-next-line no-unused-vars
function defaultComponentMapping({ hitsOwnerState }) {
  return [
    hitsOwnerState?.contentType &&
      hitsOwnerState?.searchPageType &&
      `${upperCamelCase(hitsOwnerState.contentType)}${upperCamelCase(
        hitsOwnerState.searchPageType,
      )}Hit`,
    hitsOwnerState?.searchPageType &&
      `${upperCamelCase(hitsOwnerState.searchPageType)}Hit`,
    hitsOwnerState?.contentType &&
      `${upperCamelCase(hitsOwnerState.contentType)}Hit`,
    "DefaultHit",
  ];
}

export default function HitController(props) {
  props = useThemeProps({ props, name: "AlgoliaHitController" });
  let {
    components = {},
    componentMapping = defaultComponentMapping,
    hit,
    transformHit,
    ...restProps
  } = props;

  hit = transformHit ? transformHit(hit) : hit;

  components = handleComponentsProp(components, { DefaultHit });
  let suggestedComponents = componentMapping(props, defaultComponentMapping);
  suggestedComponents = [
    ...ensureArray(suggestedComponents),
    ...ensureArray(defaultComponentMapping(props)),
  ];
  suggestedComponents = suggestedComponents.map((Component) =>
    typeof Component === "string" ? components[Component] : Component,
  );
  let Component = suggestedComponents.find(Boolean);

  if (!Component) {
    return (
      <DevNotice>
        <details>
          <summary>{`Could not map SearchHitController to a component`}</summary>
          <pre>
            <code>{JSON.stringify(props, null, 2)}</code>
          </pre>
        </details>
      </DevNotice>
    );
  }

  return <Component {...restProps} hit={hit} />;
}
